const BASE_URL = 'https://cms.m-db.nl/wp-json/mdb/v1/';

const fetchPosts = query =>
  fetch(BASE_URL + query)
    .then(response => response.json());

export {
  fetchPosts,
};
